const constants = require('@/util/constants')
require('./config')

/**
 * 获取帮助文档类别
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getCategories (successcb, failedcb) {
  axios.get('/api/category/get', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getTicketCategories (successcb, failedcb) {
  axios.get('/api/category/ticket2', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建帮助文档类别,
 * 注：当无父类别时传递0
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createCategory (parentId, name, type, successcb, failedcb) {
  axios.post('/api/category/create', {
    parentId: parentId,
    name: name,
    type: type,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新帮助文档类别
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateCategory (categoryId, name, successcb, failedcb) {
  console.log('updateCategory:', categoryId, name)
  axios.post('/api/category/update', {
    id: categoryId,
    name: name,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除帮助文档类别
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteCategory(categoryId, successcb, failedcb) {
  console.log('deleteCategory:', categoryId)
  axios.delete('/api/category/delete', {
    params: {
      id: categoryId,
      client: constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getCategoriesSupport(queryParam, successcb, failedcb) {
  axios.get('/api/category/support', {
    params: {
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getCategoriesKnowledge(queryParam, successcb, failedcb) {
  axios.get('/api/category/knowledge', {
    params: {
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getCategoriesRobot(queryParam, successcb, failedcb) {
  axios.get('/api/category/robot', {
    params: {
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getCategoriesTicket(queryParam, successcb, failedcb) {
  axios.get('/api/category/ticket', {
    params: {
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getCategoriesFeedback(queryParam, successcb, failedcb) {
  axios.get('/api/category/feedback', {
    params: {
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getCategoriesForum(queryParam, successcb, failedcb) {
  axios.get('/api/category/forum', {
    params: {
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getCategoriesCuw(queryParam, successcb, failedcb) {
  axios.get('/api/category/cuw/company', {
    params: {
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function createCategories(category, successcb, failedcb) {
  axios.post('/api/category/create', {
    parentId: 0,
    name: category.name,
    type: category.type,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function updateCategories(category, successcb, failedcb) {
  axios.post('/api/category/update', {
    parentId: category.id,
    name: category.name,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function deleteCategories(id, successcb, failedcb) {
  axios.post('/api/category/delete', {
    id: id,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function filterCategories(content, successcb, failedcb) {
  axios.get('/api/category/filter', {
    params: {
      'page': 0,
      'size': 20,
      'content': content,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
